module.exports = __webpack_public_path__ + "static/media/tool_logo_openvas.88898507.png";